import apiClient from '../api.service';

export const userService = {
    login,
    logout,
    register,
    getAll,
    getUserInfo,
};

function login(email, password) {
    console.log('[userService] login llamado con email:', email);
    return apiClient.post('/login', { email, password })
        .then(response => {
            console.log('[userService] respuesta del servidor:', response);
            const data = response.data;
            // Login exitoso si hay token en la respuesta
            if (data.token) {
                // Guardar usuario y token en localStorage
                const user = {
                    ...data.user,
                    token: data.token,
                    roles: data.roles || [],
                    permissions: data.permissions || []
                };
                localStorage.setItem('user', JSON.stringify(user));
                console.log('[userService] usuario guardado en localStorage');
                return user;
            }
            return data;
        })
        .catch(error => {
            console.error('[userService] error en login:', error);
            const message = error.response?.data?.message || error.message || 'Error al iniciar sesión';
            return Promise.reject(message);
        });
}

function logout() {
    return apiClient.post('/logout')
        .then(() => {
            // Remover usuario del localStorage
            localStorage.removeItem('user');
            return true;
        })
        .catch((error) => {
            // Incluso si falla la petición, limpiar localStorage
            localStorage.removeItem('user');
            console.error('Error durante logout:', error);
            return true;
        });
}

function register(user) {
    return apiClient.post('/register', user)
        .then(response => response.data)
        .catch(error => {
            const message = error.response?.data?.message || error.message || 'Error al registrar usuario';
            return Promise.reject(message);
        });
}

function getAll() {
    return apiClient.get('/user/list')
        .then(response => response.data)
        .catch(error => {
            const message = error.response?.data?.message || error.message || 'Error al obtener usuarios';
            return Promise.reject(message);
        });
}

function getUserInfo() {
    return apiClient.get('/user/getInfo')
        .then(response => response.data)
        .catch(error => {
            const message = error.response?.data?.message || error.message || 'Error al obtener información del usuario';
            return Promise.reject(message);
        });
}
